import $ from 'jquery';

export default function triggersLogic() {
    // Menu logic
    $('#trigger-menu').on('click', function() {
        $('#trigger-search').removeClass('is-triggered');
        $('#search-form').removeClass('is-visible');

        if ( $(this).hasClass('is-triggered') ) {
            $('html').css('overflow-y', 'auto');
            $(this).removeClass('is-triggered');
            $('#site-navigation').fadeOut(200);
        } else {
            $('html').css('overflow-y', 'hidden');
            $(this).addClass('is-triggered');
            $('#site-navigation').fadeIn(200);
        }
    });

    // Search form logic
    $('#trigger-search').on('click', function() {
        $('#trigger-menu').removeClass('is-triggered');
        $('#site-navigation').fadeOut(200);
        $('html').css('overflow-y', 'auto');
        $('#search-form').addClass('is-visible');
        $('#search-field').focus();
    });

    $('#search-close').on('click', function() {
        $('#search-form').removeClass('is-visible');
    });
}


// WEBPACK FOOTER //
// ./components/triggers-logic.js